/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShippingRate
 */
export interface ShippingRate {
    /**
     * 
     * @type {string}
     * @memberof ShippingRate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingRate
     */
    handle: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingRate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRate
     */
    price: number;
}

/**
 * Check if a given object implements the ShippingRate interface.
 */
export function instanceOfShippingRate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "handle" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "price" in value;

    return isInstance;
}

export function ShippingRateFromJSON(json: any): ShippingRate {
    return ShippingRateFromJSONTyped(json, false);
}

export function ShippingRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingRate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'handle': json['handle'],
        'name': json['name'],
        'price': json['price'],
    };
}

export function ShippingRateToJSON(value?: ShippingRate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'handle': value.handle,
        'name': value.name,
        'price': value.price,
    };
}

